import React from 'react';
import useStyles from './styles';

function ScrumCard({cardIndex, colIndex, rowIndex, onMouseUp, onMouseDown, onDragStart, onDrag, onDragEnd, id, ref, style, title, description, onTouchStart, onTouchEnd, onTouchEndCapture, onTouchMove, onCardClick}) {
  const c = useStyles();
  return (
    <div 
    style={style && style} 
    onTouchEnd={onTouchEnd && onTouchEnd} 
    onTouchEndCapture={onTouchEndCapture && onTouchEndCapture} 
    onTouchStart={onTouchStart && onTouchStart} 
    onTouchMove={onTouchMove && onTouchMove}
    onDrag={onDrag && onDrag} 
    onDragStart={onDragStart && onDragStart} 
    onDragEnd={onDragEnd && onDragEnd} 
    onDragEnd={onDragEnd && onDragEnd} 
    onMouseDown={onMouseDown && onMouseDown}
    onMouseUp={onMouseUp && onMouseUp}
    id={id && id} 
    ref={ref && ref} 
    className={c.cardContainer} 
    draggable={true}
    title={title}
    onClick={() => {if (onCardClick) onCardClick({cardIndex, colIndex, rowIndex})}}
    >
      {title}
      <div draggable={false} className={"card-description"} title={description}>{description}</div>
    </div>
  );
}

export default ScrumCard;